import { yupResolver } from "@hookform/resolvers/yup";
import FormHubSelect from "components/Common/Form/FormHubSelect";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { formValidate } from "helpers/form_helper";
import {
  useChangeCollectorType,
  useCreateCollectorScheduleChanges,
  useListCollectorCurrent,
  useListCollectorFree,
  useUpdateCollectorScheduleChanges,
} from "hooks/allocate-collector/useAllocateCollector";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import {
  Button,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import * as yup from "yup";
import { MODE_DETAIL } from "./contants";
import { useTimeSlotsCollectorSchedule } from "hooks/timeslot-collector/useTimeslotCollector";

const CreateScheduleChangeCollector = props => {
  const { isOpenModal, toggleModal, dataDetail, refetchList } = props;

  const [currentWeekOnly, setCurrentWeekOnly] = useState(true);

  const onCreateSuccess = () => {
    toggleModal();
    refetchList();
  };

  // collectorFreeParams
  const [timeSlotsScheduleParams, setTimeSlotsScheduleParams] = useState({
    date: null,
    hub_id: null,
    run: false,
  });

  const { data: timeSlots, refetch: fetchTimeSlots } =
    useTimeSlotsCollectorSchedule({
      params: timeSlotsScheduleParams,
    });

  const onUpdateSuccess = () => {
    toggleModal();
    refetchList();
  };

  const { isLoading: isLoadingCreate, mutate: mutateCreate } =
    useCreateCollectorScheduleChanges(onCreateSuccess);

  const { isLoading: isLoadingUpdate, mutate: mutateUpdate } =
    useUpdateCollectorScheduleChanges(onUpdateSuccess);

  const { t } = useTranslation(["allocateCollector"]);

  /* ================================== START INIT STATE ==================================== */

  /* =================================== END INIT STATE ===================================== */

  /* ===================================== START HOOKS ====================================== */

  /* ===================================== END HOOKS ======================================== */

  /* ================================ START FUNCTION HANDLER ================================ */

  /* ================================ END FUNCTION HANDLER ================================= */

  const schema = yup.object().shape({
    type: yup.object().required(
      t("form.validate.select", {
        title: t("form.schedule_change_collector_type"),
      })
    ),
    timeslot_ids: yup.array().min(
      1,
      t("form.validate.select", {
        title: t("form.timeslot_ids"),
      })
    ),
    collector_id_current: yup
      .object()
      .required(
        t("form.validate.select", {
          title: t("form.collector_id_current"),
        })
      )
      .test(
        "dulipcateCollectorCurrent",
        "Collector hiện tại không được trùng với Collector thay thế",
        (collector, e) => {
          if (collector && collector.value === e?.parent?.collector_id?.value) {
            return false;
          }
          return true;
        }
      )
      .nullable(),
    collector_id: yup
      .object()
      .required(
        t("form.validate.select", {
          title: t("form.collector_id"),
        })
      )
      .test(
        "dulipcateCollector",
        "Collector thay thế không được trùng với Collector hiện tại",
        (collector, e) => {
          if (
            collector &&
            collector.value === e?.parent?.collector_id_current?.value
          ) {
            return false;
          }
          return true;
        }
      )
      .nullable(),
    note: yup.string().nullable(),
    hub_id: yup
      .object()
      .nullable()
      .required(t("form.validate.select", { title: t("form.hub_id") })),
  });

  const {
    refetch: fetchListChangeCollectorType,
    data: listChangeCollectorType,
  } = useChangeCollectorType();

  // collectorFreeParams
  const [collectorFreeParams, setCollectorFreeParams] = useState({
    type: null,
    date: null,
    timeslot_ids: null,
    hub_id: null,
    run: false,
  });

  const {
    refetch: fetchListCollectorFree,
    data: listCollectorFree,
    isFetching: isFetchingCollectorFree,
  } = useListCollectorFree({
    payload: { params: collectorFreeParams },
  });

  // collectorarams
  const [collectorParams, setCollectorParams] = useState({
    type: null,
    date: null,
    timeslot_ids: null,
    hub_id: null,
    run: false,
  });

  const {
    refetch: fetchListCollectorCurrent,
    data: listCollectorCurrent,
    isFetching: isFetchingCollectorCurrent,
  } = useListCollectorCurrent({
    payload: { params: collectorParams },
  });

  const initDefaultValues = {
    type: null,
    date: [],
    timeslot_ids: [],
    collector_id_current: undefined,
    collector_id: undefined,
    hub_id: undefined,
  };

  useEffect(() => {
    if (
      collectorFreeParams &&
      collectorFreeParams.run &&
      collectorFreeParams.hub_id
    ) {
      fetchListCollectorFree();
    }
  }, [collectorFreeParams]);

  useEffect(() => {
    if (collectorParams && collectorParams.run && collectorParams.hub_id) {
      fetchListCollectorCurrent();
    }
  }, [collectorParams]);

  useEffect(() => {
    if (
      timeSlotsScheduleParams &&
      timeSlotsScheduleParams.run &&
      timeSlotsScheduleParams.hub_id
    ) {
      fetchTimeSlots();
    }
  }, [timeSlotsScheduleParams]);

  useEffect(() => {
    if (listChangeCollectorType?.length > 0) {
      setValue("type", listChangeCollectorType?.[0]);
    }
  }, listChangeCollectorType);

  useEffect(() => {
    fetchListChangeCollectorType();
  }, []);

  useEffect(() => {
    if (isOpenModal) {
      if (dataDetail) {
        setValue(
          "type",
          listChangeCollectorType?.find(
            item => item.value == dataDetail?.object_type
          ) || null
        );
        setValue("date", [new Date(dataDetail?.from_date)]);
        // setValue(
        //   "timeslot_ids",
        //   timeSlots?.filter(item =>
        //     dataDetail?.timeSlot.find(s => Number(s.id) === Number(item.value))
        //   ) || [],
        //   { shouldValidate: true }
        // );
        setValue(
          "timeslot_ids",
          dataDetail?.timeSlot.map(item => {
            return {
              value: item.id,
              label: item.name,
            };
          }) || [],
          { shouldValidate: true }
        );
        const collector = {
          value: dataDetail?.collector_id,
          label: dataDetail?.collector_name,
        };
        const collectorCurrent = {
          value: dataDetail?.collector_id_current,
          label: dataDetail?.collector_name_current,
        };
        setValue("note", dataDetail?.note);
        setValue("hub_id", null);
        setTimeout(() => {
          setValue("collector_id", collector, { shouldValidate: true });
          setValue("collector_id_current", collectorCurrent, {
            shouldValidate: true,
          });
        });
      } else {
        reset();
        setValue("type", listChangeCollectorType?.[0]);
        setValue("date", [new Date()]);
        setValue("collector_id_current", null);
        setValue("collector_id", null);
        setValue("note", "");
        setValue("hub_id", null);
      }
      setTimeout(() => {
        setCollectorFreeParams(prev => {
          return {
            ...prev,
            run: true,
          };
        });
        setCollectorParams(prev => {
          return {
            ...prev,
            run: true,
          };
        });
        setTimeSlotsScheduleParams(prev => {
          return {
            ...prev,
            run: true,
          };
        });
      });
    } else {
      setCollectorFreeParams(prev => {
        return {
          ...prev,
          hub_id: null,
          run: false,
        };
      });
      setCollectorParams(prev => {
        return {
          ...prev,
          hub_id: null,
          run: false,
        };
      });
      setTimeSlotsScheduleParams(prev => {
        return {
          ...prev,
          hub_id: null,
          run: false,
        };
      });
      setCurrentWeekOnly(false);
    }
  }, [isOpenModal, dataDetail]);

  const mainForm = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: initDefaultValues,
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
  } = mainForm;

  const typeChange = watch("type");
  const dateChange = watch("date");
  const timeSlot = watch("timeslot_ids");
  const hubWatch = watch("hub_id");

  useEffect(() => {
    if (hubWatch) {
      setValue("timeslot_ids", []);
      setTimeSlotsScheduleParams(prev => ({
        ...prev,
        hub_id: hubWatch.value,
      }));
      setValue("collector_id", null);
      setCollectorFreeParams(prev => {
        return {
          ...prev,
          hub_id: hubWatch.value,
        };
      });
      setValue("collector_id_current", null);
      setCollectorParams(prev => {
        return {
          ...prev,
          hub_id: hubWatch.value,
        };
      });
    }
  }, [hubWatch]);

  useEffect(() => {
    setCollectorFreeParams(prev => {
      return {
        ...prev,
        type: typeChange?.value,
      };
    });
    setCollectorParams(prev => {
      return {
        ...prev,
        type: typeChange?.value,
      };
    });
    if (typeChange?.value == 40 || typeChange?.value == 50) {
      setCurrentWeekOnly(true);
    } else {
      setCurrentWeekOnly(false);
    }
  }, [typeChange]);

  useEffect(() => {
    setCollectorFreeParams(prev => {
      return {
        ...prev,
        date: moment(dateChange[0]).format("YYYY-MM-DD"),
      };
    });
    setCollectorParams(prev => {
      return {
        ...prev,
        date: moment(dateChange[0]).format("YYYY-MM-DD"),
      };
    });
    setTimeSlotsScheduleParams(prev => {
      return {
        ...prev,
        date: dateChange[0]
          ? moment(dateChange[0]).format("YYYY-MM-DD")
          : undefined,
      };
    });
  }, [dateChange]);

  useEffect(() => {
    setCollectorFreeParams(prev => {
      return {
        ...prev,
        timeslot_ids: timeSlot.map(item => item?.value).join(",") || 0,
      };
    });
    setCollectorParams(prev => {
      return {
        ...prev,
        timeslot_ids: timeSlot.map(item => item?.value).join(",") || 0,
      };
    });
  }, [timeSlot]);

  const onSubmit = data => {
    const finalData = {
      runner_id: data?.collector_id?.value,
      runner_id_current: data?.collector_id_current?.value,
      object_type: data?.type?.value,
      from_date: moment(data?.date[0]).format("YYYY-MM-DD"),
      timeslot_ids: data?.timeslot_ids?.map(item => item.value).join(","),
      note: data?.note,
      hub_id: data?.hub_id?.value,
    };
    if (dataDetail) {
      mutateUpdate({
        id: dataDetail?.id,
        ...finalData,
      });
    } else {
      mutateCreate(finalData);
    }
  };
  return (
    <React.Fragment>
      <Modal
        isOpen={isOpenModal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        toggle={toggleModal}
      >
        <ModalHeader toggle={toggleModal}>
          {t("title.change_schedule")}
        </ModalHeader>
        <ModalBody>
          <Row className="row-cols-1 row-cols-md-1">
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="type">{t("form.type")} </Label>
                <Controller
                  control={control}
                  name="type"
                  render={({ field }) => (
                    <Select
                      {...field}
                      isDisabled={dataDetail?.mode === MODE_DETAIL.VIEW}
                      placeholder={t("placeholder.select", {
                        title: t("form.type"),
                      })}
                      onChange={value => {
                        field.onChange(value);
                        setValue("collector_id", null);
                        setValue("collector_id_current", null);
                      }}
                      options={listChangeCollectorType}
                      classNamePrefix="select2-selection"
                    />
                  )}
                />
                {errors.type && (
                  <MessageFormValidate error={errors.type.message} />
                )}
              </FormGroup>
            </Col>
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="date">
                  {t("form.date")} <span className="text-danger">*</span>
                </Label>
                <Controller
                  control={control}
                  name="date"
                  render={({ field }) => (
                    <Flatpickr
                      {...field}
                      disabled={dataDetail?.mode === MODE_DETAIL.VIEW}
                      className={`form-control d-block Flatpickr__Input ${formValidate(
                        errors,
                        touchedFields,
                        "date"
                      )}`}
                      placeholder="DD/MM/YYYY"
                      options={{
                        altInput: true,
                        altFormat: "d/m/Y",
                        dateFormat: "d/m/Y",
                        minDate:
                          dataDetail?.mode !== MODE_DETAIL.VIEW && "today",
                        maxDate:
                          dataDetail?.mode !== MODE_DETAIL.VIEW &&
                          currentWeekOnly &&
                          moment().endOf("isoweek").toDate(),
                        locale: {
                          firstDayOfWeek: 1,
                        },
                      }}
                      onChange={value => {
                        field.onChange(value);
                        setValue("collector_id", null);
                        setValue("collector_id_current", null);
                        setValue("timeslot_ids", []);
                      }}
                    />
                  )}
                />
                {errors.date && (
                  <MessageFormValidate error={errors.date.message} />
                )}
              </FormGroup>
            </Col>
            <Col>
              <FormHubSelect
                isMyHubOnly
                isRequired
                mainForm={mainForm}
                fieldName="hub_id"
                t={t}
                title={t("form.hub_id")}
              />
            </Col>
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="timeslot_ids">
                  {t("form.timeslot_ids")}{" "}
                  <span className="text-danger">*</span>
                </Label>
                <Controller
                  control={control}
                  name="timeslot_ids"
                  render={({ field }) => (
                    <Select
                      isClearable
                      isDisabled={
                        dataDetail?.mode === MODE_DETAIL.VIEW || !hubWatch
                      }
                      {...field}
                      isMulti
                      placeholder={t("placeholder.select", {
                        title: t("form.timeslot_ids"),
                      })}
                      onChange={value => {
                        field.onChange(value);
                        setValue("collector_id", null);
                        setValue("collector_id_current", null);
                      }}
                      options={timeSlots}
                      classNamePrefix="select2-selection"
                    />
                  )}
                />
                {errors.timeslot_ids && (
                  <MessageFormValidate error={errors.timeslot_ids.message} />
                )}
              </FormGroup>
            </Col>
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="collector_id_current">
                  {t("form.collector_id_current")}{" "}
                  <span className="text-danger">*</span>
                </Label>
                <Controller
                  control={control}
                  name="collector_id_current"
                  render={({ field }) => (
                    <Select
                      isClearable
                      isDisabled={
                        dataDetail?.mode === MODE_DETAIL.VIEW || !hubWatch
                      }
                      {...field}
                      placeholder={t("placeholder.select", {
                        title: t("form.collector_id_current"),
                      })}
                      options={listCollectorCurrent || []}
                      classNamePrefix="select2-selection"
                    />
                  )}
                />
                {errors.collector_id_current && (
                  <MessageFormValidate
                    error={errors.collector_id_current.message}
                  />
                )}
              </FormGroup>
            </Col>
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="collector_id">
                  {t("form.collector_id")}{" "}
                  <span className="text-danger">*</span>
                </Label>
                <Controller
                  control={control}
                  name="collector_id"
                  render={({ field }) => (
                    <Select
                      isClearable
                      isDisabled={
                        isFetchingCollectorFree ||
                        dataDetail?.mode === MODE_DETAIL.VIEW ||
                        !hubWatch
                      }
                      {...field}
                      placeholder={t("placeholder.select", {
                        title: t("form.collector_id"),
                      })}
                      options={listCollectorFree || []}
                      classNamePrefix="select2-selection"
                    />
                  )}
                />
                {errors.collector_id && (
                  <MessageFormValidate error={errors.collector_id.message} />
                )}
              </FormGroup>
            </Col>
            <Col>
              <FormGroup className="mb-3">
                <Label htmlFor="note">{t("form.note")}</Label>
                <textarea
                  className={`form-control ${formValidate(
                    errors,
                    touchedFields,
                    "note"
                  )}`}
                  disabled={dataDetail?.mode === MODE_DETAIL.VIEW}
                  placeholder={t("placeholder.enter", {
                    title: t("form.note"),
                  })}
                  {...register("note")}
                />
                {errors.note && (
                  <MessageFormValidate error={errors.note.message} />
                )}
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row className="justify-content-end">
            <Col className="col-auto">
              {dataDetail?.mode !== MODE_DETAIL.VIEW && (
                <Button
                  color="primary"
                  className="btn-label"
                  type="button"
                  onClick={() => {
                    handleSubmit(onSubmit)();
                  }}
                  disabled={
                    !watch("collector_id") || !watch("collector_id_current")
                  }
                >
                  <i className="bx bx-save label-icon"></i>
                  {dataDetail?.mode !== MODE_DETAIL.UPDATE
                    ? "Tạo lịch"
                    : "Cập nhật"}
                </Button>
              )}
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

CreateScheduleChangeCollector.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataDetail: PropTypes.object,
};

CreateScheduleChangeCollector.defaultProps = {
  isOpenModal: false,
  dataDetail: {},
};

export default CreateScheduleChangeCollector;
